<div [style.width.%]="100">
  <h1>選定済一覧</h1>
  <div class="element-column">
    <div class="block-row">
      <div class="element-column">
        <div class="column-list" style="width:400px; grid-template-columns: 150px 1fr;">
          <label class="list-input-title">表示モード</label>
          <div class="list-input-content">
            <app-radio-label name="grp_DispMode" label="部門" value="1" id="rbtn_bumon" #rbtn_bumon [subid]="'rbtn_bumon'"
              [(ngModel)]="selectedModel.dispMode" (change)="eventDispMode_CLICKHandler()" [forcedEnabledMode]="'true'"
              [tabindex]="0"></app-radio-label>
            <app-radio-label name="grp_DispMode" label="ページ" value="2" id="rbtn_page" #rbtn_page [subid]="'rbtn_page'"
              [(ngModel)]="selectedModel.dispMode" (change)="eventDispMode_CLICKHandler()" [forcedEnabledMode]="'true'"
              [tabindex]="0"></app-radio-label>
            <app-radio-label name="grp_DispMode" label="バイヤー" value="3" id="rbtn_buyer" #rbtn_buyer
              [subid]="'rbtn_buyer'" [(ngModel)]="selectedModel.dispMode" (change)="eventDispMode_CLICKHandler()"
              [forcedEnabledMode]="'true'" [tabindex]="0"></app-radio-label>
          </div>
          <label class="list-input-title">注文コード割当</label>
          <app-order-num-quota-code-combo-box class="list-input-content" id="cmb_OrderNumQuota_Selected"
            #cmb_OrderNumQuota_Selected [subid]="'cmb_OrderNumQuota_Selected'"
            [(ngModel)]="selectedModel.orderNumQuotaCode" [blank]="true" [initAutoLoad]="false"
            [labelField]="'OrderNumQuotaCodeName'" (loadCompleted)="orderNumQuotaLoadCompleted($event)"
            [forcedEnabledMode]="'true'" [tabindex]="0"
            [initFocusItem]="parentModel.kymw1300Component.txt_OrderCode"></app-order-num-quota-code-combo-box>
          <label class="list-input-title">会員生協</label>
          <app-coop-code-combo-box class="list-input-content" id="cmb_CoopCode" #cmb_CoopCode [subid]="'cmb_CoopCode'"
            [(ngModel)]="selectedModel.accessCoopCode" [forcedEnabledMode]="'true'" [tabindex]="0"
            [initFocusItem]="parentModel.kymw1300Component.txt_OrderCode"></app-coop-code-combo-box>
          <label class="list-input-title" #lbl_ClassCode>部門</label>
          <app-class-code-combo-box class="list-input-content" id="cmb_ClassCode" #cmb_ClassCode
            [subid]="'cmb_ClassCode'" [(ngModel)]="selectedModel.accessClassCode" [forcedEnabledMode]="'true'"
            [tabindex]="0" [initFocusItem]="parentModel.kymw1300Component.txt_OrderCode"></app-class-code-combo-box>
          <label class="list-input-title" #lbl_MiddleClassCode>中分類</label>
          <app-middle-class-code-combo-box class="list-input-content" id="cmb_MiddleClassCode" #cmb_MiddleClassCode
            [subid]="'cmb_MiddleClassCode'" [(ngModel)]="selectedModel.accessMiddleClassCode"
            [classCodeComboBoxFlg]="true" [classCode]="cmb_ClassCode.selectedClassCode" [forcedEnabledMode]="'true'"
            [tabindex]="0"></app-middle-class-code-combo-box>
          <label class="list-input-title" #lbl_SmallClassCode>小分類</label>
          <app-small-class-code-combo-box class="list-input-content" id="cmb_SmallClassCode" #cmb_SmallClassCode
            [subid]="'cmb_SmallClassCode'" [(ngModel)]="selectedModel.accessSmallClassCode"
            [classCodeComboBoxFlg]="true" [classCode]="cmb_ClassCode.selectedClassCode"
            [middleClassCode]="cmb_MiddleClassCode.selectedMiddleClassCode" [forcedEnabledMode]="'true'"
            [tabindex]="0"></app-small-class-code-combo-box>
          <label class="list-input-title" #lbl_PageNo>ページＮＯ</label>
          <app-page-combo-box class="list-input-content" id="cmb_PageNo" #cmb_PageNo [subid]="'cmb_PageNo'"
            [blank]="true" [notCarrying]="true" [allPage]="true" [labelField]="'PageNumInfo'"
            [orderCode]="parentModel.componentOrderCode" [mediumType]="parentModel.mediumType"
            [coopCode]="selectedModel.accessCoopCode" [forcedEnabledMode]="'true'" [tabindex]="0"
            [initFocusItem]="parentModel.kymw1300Component.txt_OrderCode"></app-page-combo-box>
          <label class="list-input-title" #lbl_buyerCode>バイヤーコード</label>
          <app-code-combo-box class="list-input-content" id="cmb_buyerCode" #cmb_buyerCode [subid]="'cmb_buyerCode'"
            [(ngModel)]="selectedModel.accessBuyerCode" [codeDiv]="'ct357'" [blank]="true"
            [labelField]="'codeValueName'" [forcedEnabledMode]="'true'" [tabindex]="0"
            [initFocusItem]="parentModel.kymw1300Component.txt_OrderCode"></app-code-combo-box>
          <label class="list-input-title" #lbl_KikakuRenrakuStatus>企画連絡ステータス</label>
          <app-code-combo-box class="list-input-content" id="cmb_KikakuRenrakuStatus" #cmb_KikakuRenrakuStatus [subid]="'cmb_KikakuRenrakuStatus'"
            [(ngModel)]="selectedModel.kikakuRenrakuStatus" [codeDiv]="'ctp199'" [blank]="true"
            [labelField]="'codeValueName'" [forcedEnabledMode]="'true'" [tabindex]="0"
            [initFocusItem]="parentModel.kymw1300Component.txt_OrderCode">
          </app-code-combo-box>
        </div>
      </div>

      <div class="element-column">
        <!-- ボタン群 -->
        <div class="element-row">
          <button class="btn-secondary" id="btn_bundleMixMatch" #btn_bundleMixMatch
            (click)="eventKYMW1308_CLICKHandler()" forcedEnabledMode="none" [tabindex]="0">バンドルミックスマッチ</button>
          <button class="btn-secondary" id="btn_nextGuideBatchSet" #btn_nextGuideBatchSet
            (click)="eventUpdateNextGuideLump_CLICKHandler()" forcedEnabledMode="none"
            [tabindex]="0">次回案内一括設定</button>
          <button class="btn-secondary" id="btn_nextGuideCheck" #btn_nextGuideCheck
            (click)="eventCheckNextGuide_CLICKHandler()" forcedEnabledMode="none" [tabindex]="0">次回案内チェック</button>
          <button class="btn-secondary" id="btn_printOut" #btn_printOut
            (click)="eventOutputSelectedList_CLICKHandler()" forcedEnabledMode="true" [tabindex]="0">出力</button>
          <button class="btn-primary" id="btn_display" #btn_display (click)="eventDisplaySelectedList_CLICKHandler(0)"
            forcedEnabledMode="true" [tabindex]="0">検索結果を表示</button>
        </div>

        <!-- 商品点数表 -->
        <div class="block-row">
          <table class="kymw1300-table" [style.width.px]="300">
            <tr>
              <th colspan="3" style="text-align: center;">商品点数</th>
            </tr>
            <tr>
              <th>企画回</th>
              <th>媒体</th>
              <th>{{selectedModel.goodsNumListName}}</th>
            </tr>
            <tr>
              <td class="align-right">{{selectedModel.goodsNumCatalogId | comma}}</td>
              <td class="align-right">{{selectedModel.goodsNumMedia | comma}}</td>
              <td class="align-right">{{selectedModel.goodsNumList | comma}}</td>
            </tr>
          </table>

          <table class="kymw1300-table" [style.width.px]="400">
            <tr>
              <th></th>
              <th>予算（千円）</th>
              <th>総額（千円）</th>
              <th>予算比</th>
            </tr>
            <tr>
              <th>金額</th>
              <td class="align-right">{{selectedModel.budgetPrice | comma}}</td>
              <td class="align-right">{{selectedModel.planPrice | comma}}</td>
              <td class="align-right">{{selectedModel.planPriceBudgetRatio | number:'1.1-1' | comma | suffix:'%'}}
              </td>
            </tr>
            <tr>
              <th>粗利</th>
              <td class="align-right">{{selectedModel.budgetGp | comma}}</td>
              <td class="align-right">{{selectedModel.planGp | comma}}</td>
              <td class="align-right">{{selectedModel.planGpBudgetRatio | number:'1.1-1' | comma | suffix:'%'}}</td>
            </tr>
          </table>

          <table class="kymw1300-table" [style.width.px]="400">
            <tr>
              <th></th>
              <th>GP（千円）</th>
              <th>GPR</th>
              <th>点単価</th>
            </tr>
            <tr>
              <th>今年</th>
              <td class="align-right">{{selectedModel.planGp | comma}}</td>
              <td class="align-right">{{selectedModel.planGpr | number:'1.1-1' | comma | suffix:'%'}}</td>
              <td class="align-right">{{selectedModel.planAvg | number:'1.1-1' | comma}}</td>
            </tr>
            <tr>
              <th>前年比</th>
              <td class="align-right">{{selectedModel.planGpPreviousYearRatio | number:'1.1-1' | comma | suffix:'%'}}
              </td>
              <td class="align-right">{{selectedModel.planGprPreviousYearRatio | number:'1.1-1' | comma | suffix:'%'}}
              </td>
              <td class="align-right">{{selectedModel.planAvgYearRatio | number:'1.1-1' | comma | suffix:'%'}}</td>
            </tr>
          </table>
        </div>

        <!-- 表示モード：ページ ＞ 検索 -->
        <div class="column-list" style="grid-template-columns: 64px 1fr;">
          <label class="list-input-title" id="lbl_OrderClient" #lbl_OrderClient>発注先</label>
          <div class="list-input-content">
            <input type="text" class="text-label-normal" [style.width.px]="68" id="tbx_OrderClientCode"
              #tbx_OrderClientCode [(ngModel)]="selectedModel.orderClientCode" plessInputTextSub [restrict]="'[0-9]'"
              [maxlength]="6" forcedEnabledMode="true" [tabindex]="0" />
            <input type="text" class="text-label-normal" [style.width.px]="220" id="tbx_OrderClientKanji"
              #tbx_OrderClientKanji [(ngModel)]="selectedModel.orderClientKanji" plessInputTextSub [restrict]="'[ -￮]'"
              forcedEnabledMode="true" [tabindex]="0" />
            <button class="btn-secondary" id="btn_SearchOrderClient" #btn_SearchOrderClient
              (click)="eventSearchOrdrClientHandler()" forcedEnabledMode="true" [tabindex]="0">検索</button>
          </div>
        </div>
        <div class="column-list" style="grid-template-columns: 64px 1fr;">
          <label class="list-input-title" id="lbl_PayeeClient" #lbl_PayeeClient>支払先</label>
          <div class="list-input-content">
            <input type="text" class="text-label-normal" [style.width.px]="68" id="tbx_PayeeClientCode"
              #tbx_PayeeClientCode [(ngModel)]="selectedModel.payeeClientCode" plessInputTextSub [restrict]="'[0-9]'"
              [maxlength]="6" forcedEnabledMode="true" [tabindex]="0" />
            <input type="text" class="text-label-normal" [style.width.px]="220" id="tbx_PayeeClientKanji"
              #tbx_PayeeClientKanji [(ngModel)]="selectedModel.payeeClientKanji" plessInputTextSub [restrict]="'[ -￮]'"
              forcedEnabledMode="true" [tabindex]="0" />
            <button class="btn-secondary" id="btn_SearchPayeeClient" #btn_SearchPayeeClient
              (click)="eventSearchPayeeHandler()" forcedEnabledMode="true" [tabindex]="0">検索</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 指定済一覧表 -->
    <div>
      <!-- 検索ボタン・ページング -->
      <div class="action-area">
        <div class="column-list">
          <label class="list-input-title">表示項目</label>
          <div class="list-input-content" [style.width.px]="100">
            <select id="cmb_DisplaySet" #cmb_DisplaySet [(ngModel)]="selectedModel.displayItem" forcedEnabledMode="true"
              [tabindex]="0" (keydown)="nextFocus($event)">
              <ng-template ngFor let-item [ngForOf]="selectedModel.displayItemSet">
                <option value="{{item.data}}">{{item.label}}</option>
              </ng-template>
            </select>
          </div>
        </div>
        <app-pager #selectedPager [prevDisabled]="selectedModel.totalNum === 0 || selectedModel.startDispNum <= 100"
          [nextDisabled]="selectedModel.totalNum === 0 || selectedModel.endDispNum === selectedModel.totalNum"
          [totalNum]="selectedModel.totalNum" [startNum]="selectedModel.startDispNum"
          [prevElementFunc]="getPrevFunctionChangeTab()" [endNum]="selectedModel.endDispNum"
          (prevHandler)="eventDisplaySelectedList_CLICKHandler(1)"
          (nextHandler)="eventDisplaySelectedList_CLICKHandler(2)">
        </app-pager>
      </div>
      <wj-flex-grid id="dg_SelectedItemList" #dg_SelectedItemList [itemsSource]="selectedModel.selectedList"
        [isReadOnly]="true" [allowSorting]="false" [allowDragging]="'None'" [headersVisibility]="'Column'"
        [selectionMode]="'ListBox'" [frozenColumns]="5" forcedEnabledMode="true"
        (click)="eventSelectedList_HEADERRELEASEHandler($event, dg_SelectedItemList)"
        (scrollPositionChanged)="setColorPattern(dg_SelectedItemList)" [tabindex]="0">
        <wj-flex-grid-column [minWidth]="5" [header]="' '" [allowResizing]="true" [visible]="true"
          [binding]="'DispStatus'" [width]="30">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DispStatus}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'部門'" [allowResizing]="true" [visible]="true"
          [binding]="'ClassCode'" [width]="60"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'小分類'" [allowResizing]="true" [visible]="true"
          [binding]="'SmallClassCode'" [width]="90"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'商品案内用商品名'" [allowResizing]="true" [visible]="true"
          [binding]="'GuideGoodsName'" [width]="205"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'商品案内用規格名'" [allowResizing]="true" [visible]="true"
          [binding]="'GuideStandardName'" [width]="205"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'い'" [allowResizing]="true" [visible]="true"
          [binding]="'DealEnableCoopIB'" [width]="30" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DealEnableCoopIB}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'と'" [allowResizing]="true" [visible]="true"
          [binding]="'DealEnableCoopTO'" [width]="30" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DealEnableCoopTO}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ぐ'" [allowResizing]="true" [visible]="true"
          [binding]="'DealEnableCoopGU'" [width]="30" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DealEnableCoopGU}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ち'" [allowResizing]="true" [visible]="true"
          [binding]="'DealEnableCoopTI'" [width]="30" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DealEnableCoopTI}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'さ'" [allowResizing]="true" [visible]="true"
          [binding]="'DealEnableCoopSA'" [width]="30" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DealEnableCoopSA}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'とう'" [allowResizing]="true" [visible]="true"
          [binding]="'DealEnableCoopTK'" [width]="33" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DealEnableCoopTK}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'な'" [allowResizing]="true" [visible]="true"
          [binding]="'DealEnableCoopNA'" [width]="30" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DealEnableCoopNA}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'に'" [allowResizing]="true" [visible]="true"
          [binding]="'DealEnableCoopNI'" [width]="30" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DealEnableCoopNI}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'紐付'" [allowResizing]="true" [visible]="true"
          [binding]="'RelateMasterCode'" [width]="90"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'Ｐコード'" [allowResizing]="true" [visible]="true"
          [binding]="'PCode'" [width]="90"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'企画連絡'" [allowResizing]="true" [visible]="true"
          [binding]="'KikakuRenrakuStatusName'" [width]="120"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'アイテムコード（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ItemCodeIB'" [width]="134"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'アイテムコード（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ItemCodeTO'" [width]="134"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'アイテムコード（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ItemCodeGU'" [width]="134"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'アイテムコード（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ItemCodeTI'" [width]="134"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'アイテムコード（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ItemCodeSA'" [width]="134"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'アイテムコード（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ItemCodeTK'" [width]="145"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'アイテムコード（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ItemCodeNA'" [width]="134"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'アイテムコード（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ItemCodeNI'" [width]="134"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＪＡＮ（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'JanCodeIB'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＪＡＮ（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'JanCodeTO'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＪＡＮ（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'JanCodeGU'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＪＡＮ（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'JanCodeTI'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＪＡＮ（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'JanCodeSA'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＪＡＮ（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'JanCodeTK'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＪＡＮ（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'JanCodeNA'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＪＡＮ（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'JanCodeNI'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画数（総数）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PlanNumALL'" [width]="111" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanNumALL | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画数（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PlanNumIB'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanNumIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画数（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PlanNumTO'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanNumTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画数（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PlanNumGU'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanNumGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画数（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PlanNumTI'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanNumTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画数（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PlanNumSA'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanNumSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画数（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PlanNumTK'" [width]="111" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanNumTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画数（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PlanNumNA'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanNumNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画数（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PlanNumNI'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanNumNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'商品案内温度帯'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'GuideTempZoneName'"
          [width]="125"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'バイヤーコード'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'BuyerCode'" [width]="110"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'頁（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PublishPageNumIB'"
          [width]="68"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'頁（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PublishPageNumTO'"
          [width]="68"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'頁（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PublishPageNumGU'"
          [width]="68"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'頁（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PublishPageNumTI'"
          [width]="68"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'頁（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PublishPageNumSA'"
          [width]="68"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'頁（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PublishPageNumTK'"
          [width]="78"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'頁（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PublishPageNumNA'"
          [width]="68"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'頁（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PublishPageNumNI'"
          [width]="68"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'掲載枠数（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PublishAmountLimitNumIB'" [width]="115" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PublishAmountLimitNumIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'掲載枠数（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PublishAmountLimitNumTO'" [width]="115" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PublishAmountLimitNumTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'掲載枠数（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PublishAmountLimitNumGU'" [width]="115" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PublishAmountLimitNumGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'掲載枠数（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PublishAmountLimitNumTI'" [width]="115" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PublishAmountLimitNumTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'掲載枠数（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PublishAmountLimitNumSA'" [width]="115" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PublishAmountLimitNumSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'掲載枠数（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PublishAmountLimitNumTK'" [width]="120" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PublishAmountLimitNumTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'掲載枠数（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PublishAmountLimitNumNA'" [width]="115" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PublishAmountLimitNumNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'掲載枠数（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PublishAmountLimitNumNI'" [width]="115" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PublishAmountLimitNumNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'注文コード（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OrderNumIB'" [width]="153"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'注文コード（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OrderNumTO'" [width]="153"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'注文コード（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OrderNumGU'" [width]="153"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'注文コード（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OrderNumTI'" [width]="153"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'注文コード（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OrderNumSA'" [width]="153"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'注文コード（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OrderNumTK'" [width]="153"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'注文コード（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OrderNumNA'" [width]="153"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'注文コード（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OrderNumNI'" [width]="153"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'今回供給（い）'" [allowResizing]="true" [visible]="true"
          [binding]="'ThisTimeSupplyPriceIB'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ThisTimeSupplyPriceIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'今回供給（と）'" [allowResizing]="true" [visible]="true"
          [binding]="'ThisTimeSupplyPriceTO'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ThisTimeSupplyPriceTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'今回供給（ぐ）'" [allowResizing]="true" [visible]="true"
          [binding]="'ThisTimeSupplyPriceGU'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ThisTimeSupplyPriceGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'今回供給（ち）'" [allowResizing]="true" [visible]="true"
          [binding]="'ThisTimeSupplyPriceTI'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ThisTimeSupplyPriceTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'今回供給（さ）'" [allowResizing]="true" [visible]="true"
          [binding]="'ThisTimeSupplyPriceSA'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ThisTimeSupplyPriceSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'今回供給（とう）'" [allowResizing]="true" [visible]="true"
          [binding]="'ThisTimeSupplyPriceTK'" [width]="120" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ThisTimeSupplyPriceTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'今回供給（な）'" [allowResizing]="true" [visible]="true"
          [binding]="'ThisTimeSupplyPriceNA'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ThisTimeSupplyPriceNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'今回供給（に）'" [allowResizing]="true" [visible]="true"
          [binding]="'ThisTimeSupplyPriceNI'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ThisTimeSupplyPriceNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給ＯＦＦ率（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'SupplyPriceOffPercentIB'"
          [width]="140" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceOffPercentIB | number:'1.1-1' | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給ＯＦＦ率（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'SupplyPriceOffPercentTO'"
          [width]="140" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceOffPercentTO | number:'1.1-1' | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給ＯＦＦ率（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'SupplyPriceOffPercentGU'"
          [width]="140" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceOffPercentGU | number:'1.1-1' | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給ＯＦＦ率（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'SupplyPriceOffPercentTI'"
          [width]="140" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceOffPercentTI | number:'1.1-1' | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給ＯＦＦ率（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'SupplyPriceOffPercentSA'"
          [width]="140" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceOffPercentSA | number:'1.1-1' | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給ＯＦＦ率（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'SupplyPriceOffPercentTK'"
          [width]="145" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceOffPercentTK | number:'1.1-1' | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給ＯＦＦ率（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'SupplyPriceOffPercentNA'"
          [width]="140" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceOffPercentNA | number:'1.1-1' | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給ＯＦＦ率（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'SupplyPriceOffPercentNI'"
          [width]="140" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceOffPercentNI | number:'1.1-1' | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給通常（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'SupplyPriceStandardIB'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceStandardIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給通常（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'SupplyPriceStandardTO'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceStandardTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給通常（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'SupplyPriceStandardGU'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceStandardGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給通常（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'SupplyPriceStandardTI'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceStandardTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給通常（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'SupplyPriceStandardSA'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceStandardSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給通常（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'SupplyPriceStandardTK'" [width]="120" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceStandardTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給通常（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'SupplyPriceStandardNA'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceStandardNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給通常（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'SupplyPriceStandardNI'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceStandardNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'消費税区分'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ConsumeTaxDivName'" [width]="100" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ConsumeTaxDivName}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'消費税率'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ConsumeTaxRate'" [width]="100" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ConsumeTaxRate | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'今回単品仕入価格（い）'" [allowResizing]="true" [visible]="true"
          [binding]="'ThisTimeCostPriceIB'" [width]="170" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ThisTimeCostPriceIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'今回単品仕入価格（と）'" [allowResizing]="true" [visible]="true"
          [binding]="'ThisTimeCostPriceTO'" [width]="170" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ThisTimeCostPriceTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'今回単品仕入価格（ぐ）'" [allowResizing]="true" [visible]="true"
          [binding]="'ThisTimeCostPriceGU'" [width]="170" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ThisTimeCostPriceGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'今回単品仕入価格（ち）'" [allowResizing]="true" [visible]="true"
          [binding]="'ThisTimeCostPriceTI'" [width]="170" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ThisTimeCostPriceTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'今回単品仕入価格（さ）'" [allowResizing]="true" [visible]="true"
          [binding]="'ThisTimeCostPriceSA'" [width]="170" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ThisTimeCostPriceSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'今回単品仕入価格（とう）'" [allowResizing]="true" [visible]="true"
          [binding]="'ThisTimeCostPriceTK'" [width]="175" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ThisTimeCostPriceTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'今回単品仕入価格（な）'" [allowResizing]="true" [visible]="true"
          [binding]="'ThisTimeCostPriceNA'" [width]="170" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ThisTimeCostPriceNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'今回単品仕入価格（に）'" [allowResizing]="true" [visible]="true"
          [binding]="'ThisTimeCostPriceNI'" [width]="170" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ThisTimeCostPriceNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'単品仕入通常（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'CostPriceStandardIB'" [width]="145" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.CostPriceStandardIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'単品仕入通常（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'CostPriceStandardTO'" [width]="145" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.CostPriceStandardTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'単品仕入通常（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'CostPriceStandardGU'" [width]="145" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.CostPriceStandardGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'単品仕入通常（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'CostPriceStandardTI'" [width]="145" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.CostPriceStandardTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'単品仕入通常（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'CostPriceStandardSA'" [width]="145" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.CostPriceStandardSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'単品仕入通常（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'CostPriceStandardTK'" [width]="145" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.CostPriceStandardTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'単品仕入通常（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'CostPriceStandardNA'" [width]="145" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.CostPriceStandardNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'単品仕入通常（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'CostPriceStandardNI'" [width]="145" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.CostPriceStandardNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'価格バンドル（い）'" [allowResizing]="true" [visible]="true"
          [binding]="'BundlePriceIB'" [width]="130" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.BundlePriceIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'価格バンドル（と）'" [allowResizing]="true" [visible]="true"
          [binding]="'BundlePriceTO'" [width]="130" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.BundlePriceTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'価格バンドル（ぐ）'" [allowResizing]="true" [visible]="true"
          [binding]="'BundlePriceGU'" [width]="130" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.BundlePriceGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'価格バンドル（ち）'" [allowResizing]="true" [visible]="true"
          [binding]="'BundlePriceTI'" [width]="130" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.BundlePriceTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'価格バンドル（さ）'" [allowResizing]="true" [visible]="true"
          [binding]="'BundlePriceSA'" [width]="130" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.BundlePriceSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'価格バンドル（とう）'" [allowResizing]="true" [visible]="true"
          [binding]="'BundlePriceTK'" [width]="135" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.BundlePriceTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'価格バンドル（な）'" [allowResizing]="true" [visible]="true"
          [binding]="'BundlePriceNA'" [width]="130" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.BundlePriceNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'価格バンドル（に）'" [allowResizing]="true" [visible]="true"
          [binding]="'BundlePriceNI'" [width]="130" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.BundlePriceNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＧＰＲ（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'GprIB'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.GprIB | number:'1.1-1' | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＧＰＲ（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'GprTO'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.GprTO | number:'1.1-1' | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＧＰＲ（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'GprGU'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.GprGU | number:'1.1-1' | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＧＰＲ（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'GprTI'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.GprTI | number:'1.1-1' | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＧＰＲ（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'GprSA'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.GprSA | number:'1.1-1' | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＧＰＲ（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'GprTK'" [width]="105" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.GprTK | number:'1.1-1' | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＧＰＲ（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'GprNA'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.GprNA | number:'1.1-1' | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＧＰＲ（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'GprNI'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.GprNI | number:'1.1-1' | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＧＰ（千円）（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'GpIB'" [width]="140" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.GpIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＧＰ（千円）（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'GpTO'" [width]="140" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.GpTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＧＰ（千円）（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'GpGU'" [width]="140" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.GpGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＧＰ（千円）（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'GpTI'" [width]="140" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.GpTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＧＰ（千円）（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'GpSA'" [width]="140" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.GpSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＧＰ（千円）（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'GpTK'" [width]="145" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.GpTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＧＰ（千円）（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'GpNA'" [width]="140" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.GpNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＧＰ（千円）（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'GpNI'" [width]="140" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.GpNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＧＰ（千円）（合計）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'GpALL'" [width]="155" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.GpALL | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績ＧＰ（千円）（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultGpIB'" [width]="166" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultGpIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績ＧＰ（千円）（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultGpTO'" [width]="166" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultGpTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績ＧＰ（千円）（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultGpGU'" [width]="166"  [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultGpGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績ＧＰ（千円）（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultGpTI'" [width]="166" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultGpTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績ＧＰ（千円）（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultGpSA'" [width]="166" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultGpSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績ＧＰ（千円）（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultGpTK'" [width]="175" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultGpTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績ＧＰ（千円）（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultGpNA'" [width]="166" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultGpNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績ＧＰ（千円）（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultGpNI'" [width]="166" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultGpNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'加工賃（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'FcmcFeeIB'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FcmcFeeIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'加工賃（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'FcmcFeeTO'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FcmcFeeTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'加工賃（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'FcmcFeeGU'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FcmcFeeGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'加工賃（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'FcmcFeeTI'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FcmcFeeTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'加工賃（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'FcmcFeeSA'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FcmcFeeSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'加工賃（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'FcmcFeeTK'" [width]="105" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FcmcFeeTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'加工賃（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'FcmcFeeNA'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FcmcFeeNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'加工賃（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'FcmcFeeNI'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FcmcFeeNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画額（千円）（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PlanPriceIB'" [width]="155" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanPriceIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画額（千円）（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PlanPriceTO'" [width]="155" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanPriceTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画額（千円）（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PlanPriceGU'" [width]="155" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanPriceGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画額（千円）（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PlanPriceTI'" [width]="155" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanPriceTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画額（千円）（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PlanPriceSA'" [width]="155" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanPriceSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画額（千円）（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PlanPriceTK'" [width]="160" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanPriceTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画額（千円）（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PlanPriceNA'" [width]="155" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanPriceNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画額（千円）（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PlanPriceNI'" [width]="155" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanPriceNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計画額（千円）（合計）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'PlanPriceALL'" [width]="170" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PlanPriceALL | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績数（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultNumIB'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultNumIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績数（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultNumTO'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultNumTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績数（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultNumGU'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultNumGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績数（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultNumTI'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultNumTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績数（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultNumSA'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultNumSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績数（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultNumTK'" [width]="106" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultNumTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績数（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultNumNA'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultNumNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績数（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultNumNI'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultNumNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績額（千円）（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultPriceIB'" [width]="152" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultPriceIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績額（千円）（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultPriceTO'" [width]="152" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultPriceTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績額（千円）（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultPriceGU'" [width]="152" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultPriceGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績額（千円）（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultPriceTI'" [width]="152" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultPriceTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績額（千円）（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultPriceSA'" [width]="152" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultPriceSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績額（千円）（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultPriceTK'" [width]="162" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultPriceTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績額（千円）（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultPriceNA'" [width]="152" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultPriceNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'実績額（千円）（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'ResultPriceNI'" [width]="152" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ResultPriceNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'次回案内（い）'" [allowResizing]="true" [visible]="true"
          [binding]="'NextGuideIB'" [width]="110">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [class.grid-cell-next-guide]="cell.item.NextGuideCheckIB === '1' ? true : false">
              {{cell.item.NextGuideIB}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'次回案内（と）'" [allowResizing]="true" [visible]="true"
          [binding]="'NextGuideTO'" [width]="110">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [class.grid-cell-next-guide]="cell.item.NextGuideCheckTO === '1' ? true : false">
              {{cell.item.NextGuideTO}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'次回案内（ぐ）'" [allowResizing]="true" [visible]="true"
          [binding]="'NextGuideGU'" [width]="110">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [class.grid-cell-next-guide]="cell.item.NextGuideCheckGU === '1' ? true : false">
              {{cell.item.NextGuideGU}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'次回案内（ち）'" [allowResizing]="true" [visible]="true"
          [binding]="'NextGuideTI'" [width]="110">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [class.grid-cell-next-guide]="cell.item.NextGuideCheckTI === '1' ? true : false">
              {{cell.item.NextGuideTI}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'次回案内（さ）'" [allowResizing]="true" [visible]="true"
          [binding]="'NextGuideSA'" [width]="110">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [class.grid-cell-next-guide]="cell.item.NextGuideCheckSA === '1' ? true : false">
              {{cell.item.NextGuideSA}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'次回案内（とう）'" [allowResizing]="true" [visible]="true"
          [binding]="'NextGuideTK'" [width]="120">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [class.grid-cell-next-guide]="cell.item.NextGuideCheckTK === '1' ? true : false">
              {{cell.item.NextGuideTK}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'次回案内（な）'" [allowResizing]="true" [visible]="true"
          [binding]="'NextGuideNA'" [width]="110">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [class.grid-cell-next-guide]="cell.item.NextGuideCheckNA === '1' ? true : false">
              {{cell.item.NextGuideNA}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'次回案内（に）'" [allowResizing]="true" [visible]="true"
          [binding]="'NextGuideNI'" [width]="110">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [class.grid-cell-next-guide]="cell.item.NextGuideCheckNI === '1' ? true : false">
              {{cell.item.NextGuideNI}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'PayeeClientNameIB'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'PayeeClientNameTO'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'PayeeClientNameGU'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'PayeeClientNameTI'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'PayeeClientNameSA'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'PayeeClientNameTK'"
          [width]="145"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'PayeeClientNameNA'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '1' ? false : true" [binding]="'PayeeClientNameNI'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'発注先取引先（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OrderClientNameIB'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'発注先取引先（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OrderClientNameTO'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'発注先取引先（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OrderClientNameGU'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'発注先取引先（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OrderClientNameTI'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'発注先取引先（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OrderClientNameSA'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'発注先取引先（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OrderClientNameTK'"
          [width]="145"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'発注先取引先（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OrderClientNameNA'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'発注先取引先（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OrderClientNameNI'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'登場区分（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'AppearNameIB'"
          [width]="110"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'登場区分（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'AppearNameTO'"
          [width]="110"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'登場区分（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'AppearNameGU'"
          [width]="110"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'登場区分（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'AppearNameTI'"
          [width]="110"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'登場区分（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'AppearNameSA'"
          [width]="110"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'登場区分（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'AppearNameTK'"
          [width]="120"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'登場区分（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'AppearNameNA'"
          [width]="110"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'登場区分（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'AppearNameNI'"
          [width]="110"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'価格パターン（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PricePatternNameIB'"
          [width]="130"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'価格パターン（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PricePatternNameTO'"
          [width]="128"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'価格パターン（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PricePatternNameGU'"
          [width]="128"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'価格パターン（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PricePatternNameTI'"
          [width]="128"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'価格パターン（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PricePatternNameSA'"
          [width]="128"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'価格パターン（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PricePatternNameTK'"
          [width]="136"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'価格パターン（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PricePatternNameNA'"
          [width]="130"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'価格パターン（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PricePatternNameNI'"
          [width]="128"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'原産国加工地（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OriginPlaceIB'" [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'原産国加工地（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OriginPlaceTO'" [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'原産国加工地（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OriginPlaceGU'" [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'原産国加工地（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OriginPlaceTI'" [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'原産国加工地（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OriginPlaceSA'" [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'原産国加工地（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OriginPlaceTK'" [width]="146"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'原産国加工地（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OriginPlaceNA'" [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'原産国加工地（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'OriginPlaceNI'" [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'バンドル（い）'" [allowResizing]="true" [visible]="true"
          [binding]="'PromotionNoIB'" [width]="102"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'バンドル（と）'" [allowResizing]="true" [visible]="true"
          [binding]="'PromotionNoTO'" [width]="102"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'バンドル（ぐ）'" [allowResizing]="true" [visible]="true"
          [binding]="'PromotionNoGU'" [width]="102"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'バンドル（ち）'" [allowResizing]="true" [visible]="true"
          [binding]="'PromotionNoTI'" [width]="102"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'バンドル（さ）'" [allowResizing]="true" [visible]="true"
          [binding]="'PromotionNoSA'" [width]="102"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'バンドル（とう）'" [allowResizing]="true" [visible]="true"
          [binding]="'PromotionNoTK'" [width]="112"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'バンドル（な）'" [allowResizing]="true" [visible]="true"
          [binding]="'PromotionNoNA'" [width]="102"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'バンドル（に）'" [allowResizing]="true" [visible]="true"
          [binding]="'PromotionNoNI'" [width]="102"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'成立価格（い）'" [allowResizing]="true" [visible]="true"
          [binding]="'ApprovedPriceIB'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ApprovedPriceIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'成立価格（と）'" [allowResizing]="true" [visible]="true"
          [binding]="'ApprovedPriceTO'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ApprovedPriceTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'成立価格（ぐ）'" [allowResizing]="true" [visible]="true"
          [binding]="'ApprovedPriceGU'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ApprovedPriceGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'成立価格（ち）'" [allowResizing]="true" [visible]="true"
          [binding]="'ApprovedPriceTI'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ApprovedPriceTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'成立価格（さ）'" [allowResizing]="true" [visible]="true"
          [binding]="'ApprovedPriceSA'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ApprovedPriceSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'成立価格（とう）'" [allowResizing]="true" [visible]="true"
          [binding]="'ApprovedPriceTK'" [width]="120" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ApprovedPriceTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'成立価格（な）'" [allowResizing]="true" [visible]="true"
          [binding]="'ApprovedPriceNA'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ApprovedPriceNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'成立価格（に）'" [allowResizing]="true" [visible]="true"
          [binding]="'ApprovedPriceNI'" [width]="110" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ApprovedPriceNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'バイヤーコメント'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'BuyerComment'"
          [width]="200"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名称（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'MakerNameIB'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名称（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'MakerNameTO'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名称（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'MakerNameGU'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名称（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'MakerNameTI'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名称（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'MakerNameSA'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名称（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'MakerNameTK'" [width]="140"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名称（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'MakerNameNA'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名称（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'MakerNameNI'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ブランド区分（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'BrandNameIB'"
          [width]="127"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ブランド区分（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'BrandNameTO'"
          [width]="127"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ブランド区分（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'BrandNameGU'"
          [width]="127"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ブランド区分（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'BrandNameTI'"
          [width]="127"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ブランド区分（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'BrandNameSA'"
          [width]="127"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ブランド区分（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'BrandNameTK'"
          [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ブランド区分（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'BrandNameNA'"
          [width]="127"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ブランド区分（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'BrandNameNI'"
          [width]="127"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'セット企画（い）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'SetPromotionNoIB'"
          [width]="115"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'セット企画（と）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'SetPromotionNoTO'"
          [width]="115"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'セット企画（ぐ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'SetPromotionNoGU'"
          [width]="115"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'セット企画（ち）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'SetPromotionNoTI'"
          [width]="115"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'セット企画（さ）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'SetPromotionNoSA'"
          [width]="115"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'セット企画（とう）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'SetPromotionNoTK'"
          [width]="125"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'セット企画（な）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'SetPromotionNoNA'"
          [width]="115"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'セット企画（に）'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '3'" [binding]="'SetPromotionNoNI'"
          [width]="115"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'抽選商品当選数'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'WinningGoodsNum'"
          [width]="115" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.WinningGoodsNum | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'1人当たりの抽選商品当選数'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'WinningGoodsPerPersonNum'"
          [width]="190" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.WinningGoodsPerPersonNum | comma}}</div>
          </ng-template></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ポイント交換注文番号'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PointExchangeOrderNum'"
          [width]="150"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ポイント交換本体相当額'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'PointExchangeEquivalentAmount'"
          [width]="160" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.PointExchangeEquivalentAmount | comma}}</div>
          </ng-template></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'交換ポイント'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'ExchangePoints'"
          [width]="130" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.ExchangePoints | comma}}</div>
          </ng-template></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'1物N価用注文番号'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'NvalOrderNum'"
          [width]="150"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'1物N価用値引後供給単価'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'NvalDiscountSupplyUnitPrice'"
          [width]="190" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.NvalDiscountSupplyUnitPrice | comma}}</div>
          </ng-template></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'クーポン注文コード'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'CouponOrderNum'"
          [width]="125"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'クーポン値引後供給単価'" [allowResizing]="true"
          [visible]="selectedModel.displayItem === '2' ? false : true" [binding]="'CouponDiscountSupplyUnitPrice'"
          [width]="170" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.CouponDiscountSupplyUnitPrice | comma}}</div>
          </ng-template></wj-flex-grid-column>
      </wj-flex-grid>
    </div>
  </div>
</div>